import { useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Section } from "@/components/common/DetailFields";
import { GoogleButton } from "@/components/auth/GoogleButton";

const SetCredentials = () => {
  const { user, setUser } = useAuth();
  const [f, setF] = useState({ username: user.username, password: "", confirm: "" });
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    if (f.password.length < 8) return toast.error("La contraseña debe tener al menos 8 caracteres");
    if (f.password !== f.confirm) return toast.error("Las contraseñas no coinciden");
    setBusy(true);
    try { const { data } = await api.post("/auth/set-credentials", { username: f.username.trim().toLowerCase(), password: f.password }); setUser((u) => ({ ...u, ...data })); toast.success("Usuario y contraseña guardados"); } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };
  return (
    <form onSubmit={submit} data-testid="set-credentials-form" className="space-y-2 pt-3 border-t c-line">
      <p className="text-sm font-semibold">Definir usuario y contraseña</p>
      <p className="text-xs c-muted">Así también podrás entrar sin Google.</p>
      <input data-testid="setcred-username-input" className="c-input font-mono" value={f.username} onChange={(e) => setF((s) => ({ ...s, username: e.target.value }))} aria-label="Usuario" />
      <input data-testid="setcred-password-input" type="password" autoComplete="new-password" placeholder="Contraseña (mín. 8)" className="c-input" value={f.password} onChange={(e) => setF((s) => ({ ...s, password: e.target.value }))} />
      <input data-testid="setcred-confirm-input" type="password" autoComplete="new-password" placeholder="Confirmar" className="c-input" value={f.confirm} onChange={(e) => setF((s) => ({ ...s, confirm: e.target.value }))} />
      <button data-testid="setcred-submit-btn" disabled={busy} className="c-btn-primary w-full py-3 flex items-center justify-center gap-2">{busy && <Loader2 className="w-4 h-4 animate-spin" />} Guardar</button>
    </form>
  );
};

export const GoogleAccountSection = () => {
  const { user, setUser } = useAuth();
  const unlink = async () => {
    try { const { data } = await api.post("/auth/google/unlink"); setUser((u) => ({ ...u, ...data })); toast.success("Google desvinculado"); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <Section title="Cuenta de Google" testid="config-google">
      {user.google_email ? (
        <div className="space-y-2">
          <p className="text-sm">Vinculada: <span data-testid="google-linked-email" className="font-mono">{user.google_email}</span></p>
          <button data-testid="google-unlink-btn" disabled={!user.has_password} onClick={unlink} className="w-full py-2.5 rounded-xl c-card text-sm font-semibold disabled:opacity-50">Desvincular</button>
          {!user.has_password && <p className="text-xs c-muted">Para desvincular, primero define un usuario y contraseña.</p>}
        </div>
      ) : (
        <div className="space-y-2">
          <p data-testid="google-not-linked" className="text-sm c-text-2">Vincula tu cuenta de Google para entrar con un toque.</p>
          <GoogleButton testid="google-link-btn" label="Vincular con Google" mode="link" returnPath="/conecta/config" />
        </div>
      )}
      {!user.has_password && <SetCredentials />}
    </Section>
  );
};
